// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"def174e1e1ca565e","931":"38f25eec51527df3"}[chunkId] + ".css";
};